import request from '@/utils/request'

export function adminLogin (data) {
  return request.post('/admin/login', data)
}

export function getAdminMe () {
  return request.get('/admin/me')
}

export function getDashboard () {
  return request.get('/admin/dashboard')
}

export function getRecordPage (params) {
  return request.get('/admin/records', { params })
}

export function approveRecord (id) {
  return request.post(`/admin/records/${id}/approve`)
}

export function rejectRecord (id, data) {
  return request.post(`/admin/records/${id}/reject`, data)
}

export function deleteRecord (id) {
  return request.delete(`/admin/records/${id}`)
}

export function batchRecheckAI (status) {
  return request.post('/admin/records/batch-recheck-ai', null, { params: { status } })
}

export function getUserPage (params) {
  return request.get('/admin/users', { params })
}

export function updateUserStatus (id, data) {
  return request.put(`/admin/users/${id}/status`, data)
}

export function getBadgeList () {
  return request.get('/admin/badges')
}

export function updateBadge (id, data) {
  return request.put(`/admin/badges/${id}`, data)
}

export function getBannerList () {
  return request.get('/admin/banners')
}

export function saveBanner (data) {
  return request.post('/admin/banners', data)
}

export function updateBanner (id, data) {
  return request.put(`/admin/banners/${id}`, data)
}

export function deleteBanner (id) {
  return request.delete(`/admin/banners/${id}`)
}

export function getConfigs () {
  return request.get('/admin/configs')
}

export function updateConfigs (data) {
  return request.put('/admin/configs', data)
}

export function getOssConfig () {
  return request.get('/admin/configs/oss')
}

export function updateOssConfig (data) {
  return request.put('/admin/configs/oss', data)
}

export function getPosterTemplateList (params) {
  return request.get('/poster-templates', { params })
}

export function getPosterTemplateById (id) {
  return request.get(`/poster-templates/${id}`)
}

export function getPosterTemplateByProject (projectId) {
  return request.get('/api/poster-templates/by-project', { params: { projectId } })
}

export function createPosterTemplate (data) {
  return request.post('/poster-templates', data)
}

export function updatePosterTemplate (id, data) {
  return request.put(`/poster-templates/${id}`, data)
}

export function deletePosterTemplate (id) {
  return request.delete(`/poster-templates/${id}`)
}

export function updatePosterTemplateStatus (id, status) {
  return request.put(`/api/poster-templates/${id}/status`, null, { params: { status } })
}

export function setPosterTemplateDefault (id) {
  return request.put(`/api/poster-templates/${id}/set-default`)
}

export function getProjectList () {
  return request.get('/projects')
}

export function getAdminProjectList () {
  return request.get('/projects/admin')
}

export function getProjectById (id) {
  return request.get(`/projects/${id}`)
}

export function createProject (data) {
  return request.post('/projects/admin', data)
}

export function updateProject (id, data) {
  return request.put(`/projects/admin/${id}`, data)
}

export function deleteProject (id) {
  return request.delete(`/projects/admin/${id}`)
}
